var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Colors, Typography } from '../../../theme';
import { isolateComponent, labelStyles, withModifier, } from '@zapier/style-encapsulation';
const defaultProps = {
    color: 'neutral800',
    tag: 'span',
    textAlign: 'inherit',
    type: 'paragraph3',
    hasTransition: true,
};
const Styles = labelStyles('Text', {
    root: (props) => [
        withModifier(props.type, Typography[props.type]),
        withModifier(props.color, { color: Colors[props.color] }),
        props.fontWeight &&
            withModifier(`fontWeight-${props.fontWeight}`, {
                fontWeight: props.fontWeight,
            }),
        {
            margin: props.margin,
            maxWidth: '100%',
            textAlign: props.textAlign,
        },
        props.hasTransition && {
            transition: 'color 0.2s ease-in-out',
        },
    ],
});
export const Text = (_a) => {
    var { color, hasTransition = true, tag = 'span', textAlign = 'inherit', type = 'paragraph3' } = _a, props = __rest(_a, ["color", "hasTransition", "tag", "textAlign", "type"]);
    const interpolatedProps = Object.assign({ color: color !== null && color !== void 0 ? color : 'neutral800', hasTransition,
        tag,
        textAlign,
        type }, props);
    return (isolateComponent(interpolatedProps.tag, { css: Styles.root(interpolatedProps) }, interpolatedProps.children));
};
//# sourceMappingURL=Text.js.map
// @zapier/design-system@5.21.5 (00611e727)
